import React, { useRef } from 'react';
import Hero from '../components/Hero';
import LogoMarquee from '../components/LogoMarquee';
import BrandsGrid from '../components/BrandsGrid';
import Process from '../components/Process';
import Capabilities from '../components/Capabilities';
import GlobalSourcing from '../components/GlobalSourcing';
import ShowroomTeaser from '../components/ShowroomTeaser';
import DecadesTeaser from '../components/DecadesTeaser';
import Contact from '../components/Contact';
import BuildTogetherPopup from '../components/BuildTogetherPopup';

const HomePage = () => {
  // Ref for the sentinel that triggers the popup
  const popupTriggerRef = useRef(null);

  return (
    <main>
      <Hero />
      <LogoMarquee />
      <BrandsGrid useLogos={true} />
      <Process />
      <Capabilities />
      <GlobalSourcing />
      <ShowroomTeaser />
      <DecadesTeaser />
      <Contact />
      {/* Sentinel element at the end of Contact section to trigger popup */}
      <div
        ref={popupTriggerRef}
        className="h-1"
        style={{ marginTop: '-1px' }}
        aria-hidden="true"
      />
      {/* Floating bottom popup - appears after scrolling past Contact */}
      <BuildTogetherPopup triggerRef={popupTriggerRef} />
    </main>
  );
};

export default HomePage;
